// extracted by mini-css-extract-plugin
module.exports = {"rows":"UserForm_rows__3xyPi","row":"UserForm_row__AsUNr","buttonRow":"UserForm_buttonRow__1bT0F","error":"UserForm_error__1Y8hR"};